import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { BreadcrumbItem, Breadcrumbs } from '../../components/Breadcrumbs';
import { StyledButton } from '../../components/Button';
import { StyledColumn } from '../../components/StyledColumn';
import { StyledRow } from '../../components/StyledRow';
import { ButtonIcon } from '../../icons/Icon';
import { PageRoutesEnum } from '../../utils/routes';

import { EmailData } from './EmailData';
import { useGetEmail } from './useGetEmail';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 24px;
  min-height: 100vh;
`;

const ConvertIcon = styled(ButtonIcon).attrs({
  name: 'Convert',
})``;

type HeaderProps = {
  subject?: string;
  id: string;
};

const Header: React.FC<HeaderProps> = ({ subject, id }) => {
  const navigate = useNavigate();
  const handleConvert = () => {
    navigate(`${PageRoutesEnum.emailConvert}/${id}`);
  };

  const breadcrumbItems = [
    {
      title: <BreadcrumbItem path={PageRoutesEnum.emails} title="Emails" />,
    },
    {
      title: <BreadcrumbItem title={`${subject}`} />,
    },
  ];

  return (
    <StyledRow justifyContent="space-between" flexGrow="0">
      <StyledColumn>
        <Breadcrumbs breadcrumbItems={breadcrumbItems} />
      </StyledColumn>
      <StyledColumn>
        <StyledButton type="primary" icon={<ConvertIcon />} onClick={handleConvert}>
          Convert to Candidate
        </StyledButton>
      </StyledColumn>
    </StyledRow>
  );
};

export const EmailDetails: React.FC = () => {
  const { id } = useParams();
  const { data: email } = useGetEmail(id || '');

  if (!email) return <></>;

  const { sentDate, from, subject, body, attachments, uuid } = email;

  return (
    <PageContainer>
      <Header subject={email.subject} id={uuid} />
      <EmailData sentDate={sentDate} from={from} subject={subject} body={body} attachments={attachments} />
    </PageContainer>
  );
};
